export const ERR_INVALID_VALUE = 'ERR_INVALID_VALUE';
export const ERR_UNEXPECTED_VALUE = 'ERR_UNEXPECTED_VALUE';
export const ERR_UNEXPECTED_TYPE = 'ERR_UNEXPECTED_TYPE';
export const ERR_PARSE = 'ERR_PARSE';
